<template>
  <v-container class="page">
    <Headline
      :title="headlineText"
      icon="mdi-label-percent-outline"
    />
    <router-view
      v-if="$store.state.condAdmin.conditionList != null"
      @setPageMode="setPageMode"
      @cancel="headlineText = $t('condAdmin.conditionList.headline')"
    ></router-view>
  </v-container>
</template>

<script lang="js">
import Headline from '@/common/Headline.vue';
import { newMessage } from '@/base/js/ProcessDataHelper';
import condAdminConditionMixin from './js/condAdminConditionMixin.js';

export default {
  name: 'Condition',
  mixins: [ condAdminConditionMixin ],
  components: {
    Headline
  },
  data () {
    return {
      pageMode: 'table', // values: table, edit
      headlineText: this.$t('condAdmin.conditionList.headline')
    };
  },
  async mounted () {
    if (this.$store.state.condAdmin.orgSettings.showConditions !== true || (this.$route.path.startsWith('/condAdmin/condition') && !this.hasUserRight('readCondition'))) {
      if (this.$store.state.condAdmin.orgSettings.showResidualValues === true && this.hasUserRight('readResidualValues')) {
        this.$router.push('/condAdmin/product');
      } else if (this.$store.state.condAdmin.orgSettings.showBaseData === true && this.hasUserRight('readBaseData')) {
        this.$router.push('/condAdmin/productType');
      } else {
        this.$globals.Info.open([newMessage('userError', this.$t('base.error.mismatchingRights'))]);
      }
      return;
    }
    if (this.$store.state.condAdmin.conditionList == null || this.$store.state.condAdmin.conditionList.length === 0) {
      await this.refreshConditionList();
    }
  },
  methods: {
    setPageMode (mode, headlineParam = '') {
      this.pageMode = mode;
      switch (mode) {
        case 'edit':
          this.headlineText = headlineParam + ' - ' + this.$t('condAdmin.conditionList.conditionEdit');
          break;
        case 'copy':
        case 'new':
          this.headlineText = this.$t('condAdmin.conditionList.conditionCreate');
          break;
        case 'view':
          this.headlineText = /* this.$t('condAdmin.conditionList.conditionEdit') + ': ' + */ headlineParam;
          break;
        default: // 'table':
          this.headlineText = this.$t('condAdmin.conditionList.headline');
          break;
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
